<template>
  <transition>
    <div class="modal-mask" :class="customClass">
      <div class="modal-wrapper" role="dialog">
        <div class="modal-container" :style="style">

          <div class="modal-header">
            <slot name="header">
              {{title || 'default header'}}
            </slot>
            <button type="button" class="close xs-close"  @click="$emit('close')">&times;</button>
          </div>

          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              {{footerText || 'default footer'}}
              <button class="modal-default-button" @click="$emit('close')" v-if="showClose">
                {{closeTitle || 'close'}}
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
    export default {
      name: "DKLModal",

      props: {
        title: {
          type: String,
          default: ''
        },
        showClose: {
          type: Boolean,
          default: true
        },
        footerText: {
          type: String,
          default: ''
        },
        closeTitle: {
          type: String,
          default: ''
        },
        width: String,
        fullscreen: Boolean,
        customClass: {
          type: String,
          default: ''
        },
        top: {
          type: String,
          default: '50px'
        },
      },
      mounted() {
      },
      computed: {
        style() {
          let style = {};
          if (!this.fullscreen) {
            style.marginTop = this.top;
            if (this.width) {
              style.width = this.width;
            }
          }
          return style;
        }
      },

    }
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 300px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
    max-height: calc(100vh - 50px);
    overflow-y: auto;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the modal transition by editing
   * these styles.
   */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  .close {
    right: 25px;
    top: 20px;
  }

</style>
